import { useLayoutEffect, useMemo } from 'react';
import { ConfigProvider } from 'antd';
import { ApolloProvider } from '@apollo/client';
import { container } from '../apollo-client/container';
import { getTheme } from '@/lib/antd/antd-theme';
import { useEffectiveThemeMode } from '@shared/store/theme.store';
import '../../shared/components/antd/notification/notification';
import ChargebeeProvider from './chargebee/chargebee-context';

export default function PublicProviders({ children }: { children: JSX.Element }) {
  const mode = useEffectiveThemeMode();
  const theme = useMemo(() => getTheme(mode), [mode]);

  // Drives the CSS-variable palette in App.css. Layout effect so the attribute changes before paint;
  // the index.html inline script sets the same attribute for the very first paint.
  useLayoutEffect(() => {
    document.documentElement.dataset.theme = mode;
  }, [mode]);

  return (
    <ApolloProvider client={container.apolloClient}>
      <ConfigProvider theme={theme}>
        <ChargebeeProvider>{children}</ChargebeeProvider>
      </ConfigProvider>
    </ApolloProvider>
  );
}
